export enum ImageBreakpoint {
    SMALL = 470,
    MEDIUM = 768,
    LARGE = 1024,
}